// CSS: {{ 'rotating-text-banner.css' | asset_url | stylesheet_tag }}

class RotatingTextBanner extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector('.rtb-text__wrapper');
    this.text = this.wrapper.querySelectorAll('*');
    this.createBanner();
    this.initRotating();
  }

  createBanner() {
    const items = this.text.length;
    const cloneLength = items === 1 ? 4 : 2;
    
    if(items > 0) {
      for (let i = 0; i < cloneLength; i++) {
        this.text.forEach(text => {
          const clone = text.cloneNode(true);
          this.wrapper.appendChild(clone);
        })
      }
    }
  }

  initRotating() {
    const cloneRTB = this.wrapper.cloneNode(true);
    this.appendChild(cloneRTB);
    this.wrapper.classList.add('rtb-animation');
    cloneRTB.classList.add('rtb-animation').style.animationDelay = '0.5s';
  }
}

customElements.define('rotating-text-banner', RotatingTextBanner);